const ArrowBackIcon = ({ className = '', ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='8'
      height='14'
      viewBox='0 0 8 14'
      className={className}
      {...props}
    >
      <path d='M4.76837e-07 7C4.76837e-07 6.74806 0.0982242 6.49613 0.287656 6.30717L6.32142 0.288678C6.7073 -0.096226 7.32471 -0.096226 7.71059 0.288678C8.09647 0.673582 8.09647 1.28943 7.71059 1.67433L2.37141 7L7.71059 12.3257C8.09647 12.7106 8.09647 13.3264 7.71059 13.7113C7.32471 14.0962 6.7073 14.0962 6.32142 13.7113L0.287656 7.69283C0.0982242 7.50387 4.76837e-07 7.25194 4.76837e-07 7Z' />
    </svg>
  );
};

export default ArrowBackIcon;
